<script>
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  props: {
    label: String,
    highlight: {
      type: Boolean,
      default: false,
    },
    tooltip: { type: String, default: null },
    description: { type: String, default: null },
  },
  computed: {
    groupingClasses() {
      if (this.highlight) {
        return [
          'cly-vue-form-step__section-group',
          'cly-vue-form-step__section-group--filled',
        ];
      }
      return '';
    },
    labelClasses() {
      if (this.highlight) {
        return 'bu-mb-4';
      }
      return '';
    },
  },
});
</script>
<template>
  <div class="cly-vue-form-step__auto-group">
    <h4
      v-if="label"
      class="bu-is-flex bu-is-align-items-baseline"
      :class="labelClasses"
    >
      {{ label }}
      <cly-tooltip-icon
        v-if="tooltip"
        class="bu-is-flex-grow-1 bu-ml-2"
        :tooltip="tooltip"
      />
    </h4>
    <span
      v-if="description"
      class="color-cool-gray-50 text-small bu-mb-1"
    >{{ description }}</span>
    <div :class="groupingClasses">
      <slot />
    </div>
  </div>
</template>
